import { writable } from 'svelte/store';

export const volume = writable(0.5);
export const muted = writable(false);
export const pendingPlayback = writable(false);

export function updateVolumeUI(vol: number) { volume.set(vol); }
export function updateMuteUI(m: boolean) { muted.set(m); }
export function updatePendingPlayback(pending: boolean) { pendingPlayback.set(pending); }
